import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CarriertransactionService {

  private transactionlist = new BehaviorSubject<object>([]);
  currentlist = this.transactionlist.asObservable();

  constructor() { }

  statementlist: any=[];
  screen: string;
  debtoraccount: any
  accountnumber: string;
  referencenumber:string;
  personid: string;
  carrierid:string;
  invoicedetails

  changeList(list: any)
  {
    this.transactionlist.next(list);
  }

}
